import React, { ReactNode } from 'react';
import classNames from 'classnames';

interface Props {
  children: ReactNode;
  wideContent?: boolean;
  hasPadding?: boolean;
  className?: string;
}

// We should be using a standardized grid but unfortunately that's the state we're currently in.
// Use this to center content on the screen. Content will stretch as far as 800px in width but is fluid for under 800px.
const CenteredContainer = ({
  children,
  wideContent = false,
  hasPadding = true,
  className
}: Props) => (
  <div className={classNames({ 'px-5': hasPadding })}>
    <div
      className={classNames(
        'md:mx-auto',
        wideContent ? 'md:max-w-[1200px]' : 'md:max-w-[800px]',
        className
      )}
    >
      {children}
    </div>
  </div>
);

export default CenteredContainer;
